import React from 'react';
import { Typography, Button } from '@notch-ordering/ui-components';
import SpinnerIcon from '@icons/spinner-icon.svg';
import { useParams } from 'react-router-dom';
import { useSupplierStore } from '@/ar/stores/SupplierStore';
import { useDraftInvoiceUpdateMutation } from '@/ar/hooks/mutations/DraftInvoiceMutations';
import { DraftInvoiceStatus } from '@/ar/network/AccountsReceivable.network';

export const DraftInvoiceProcessingModal: React.FC = () => {
    const { invoiceID } = useParams();
    const { supplierLoginData } = useSupplierStore();
    const draftInvoiceUpdateMutation = useDraftInvoiceUpdateMutation();

    const handleOverrideProcessing = async () => {
        if (!invoiceID || !supplierLoginData?.supplier_id) return;

        await draftInvoiceUpdateMutation.mutateAsync({
            draftInvoiceID: invoiceID,
            supplierID: supplierLoginData.supplier_id,
            body: {
                status: DraftInvoiceStatus.Draft,
                external_id: invoiceID,
            }
        });
    };

    return (
        <div className="absolute -left-10 top-0 right-0 bottom-0 flex items-center justify-center bg-gray-700 bg-opacity-50 z-50 w-[calc(100%+5rem)]">
            <div className="bg-white rounded-lg shadow-lg p-8 text-center flex flex-col gap-4 w-full mx-4 lg:mx-0 lg:w-[320px]">
                <SpinnerIcon className="animate-spin h-6 w-6 mx-auto"/>
                <Typography className="font-medium m-0">Parsing invoice data</Typography>
                <Typography className="m-0 mb-3 text-gray-600">Please wait a little while we take your invoice up a notch!</Typography>
                <Button
                    variant="SECONDARY"
                    size="SMALL"
                    onClick={handleOverrideProcessing}
                    loading={draftInvoiceUpdateMutation.isLoading}>
                    Skip processing
                </Button>
            </div>
        </div>
    );
};
